import { OrderMethod } from '../../../../../services/exports/Constants';

export default {
  [OrderMethod.Pickup]: 'Afhentning',
  [OrderMethod.Delivery]: 'Levering',
  [OrderMethod.OnSite]: 'På stedet',
};
